import React from 'react';
import { Plus, Type, Image as ImageIcon, Square } from 'lucide-react';

interface EmptyCanvasPlaceholderProps {
  onAddElement: (type: 'text' | 'image' | 'rect') => void;
}

export function EmptyCanvasPlaceholder({ onAddElement }: EmptyCanvasPlaceholderProps) {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
      <div className="pointer-events-auto flex flex-col items-center gap-4 p-8 rounded-2xl bg-white/80 backdrop-blur-sm border border-dashed border-gray-300">
        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
          <Plus className="h-7 w-7 text-primary" />
        </div>
        <div className="text-center">
          <p className="text-sm font-medium text-gray-700">Start designing</p>
          <p className="text-xs text-gray-500 mt-1">Click below to add your first element</p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => onAddElement('text')}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-gray-600 hover:border-primary hover:text-primary transition-colors"
          >
            <Type className="h-3.5 w-3.5" />
            Text
          </button>
          <button
            onClick={() => onAddElement('image')}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-gray-600 hover:border-primary hover:text-primary transition-colors"
          >
            <ImageIcon className="h-3.5 w-3.5" />
            Image
          </button>
          <button
            onClick={() => onAddElement('rect')}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-gray-600 hover:border-primary hover:text-primary transition-colors"
          >
            <Square className="h-3.5 w-3.5" />
            Shape
          </button>
        </div>
      </div>
    </div>
  );
}
